import React, { Component } from 'react';
import { Row, Col, Layout, Form, Input,TimePicker, Checkbox} from 'antd';
import Icon from 'components/Icon';
import CSSAnimate from 'components/CSSAnimate';
import PictureShow from 'components/PictureShow';
import {
  defaultTextArea,
  defaultDateArea,
  defaultTimeArea,
  defaultWeatherArea,
  defaultBgArea,
  defaultSTextArea,
  defaultFloorArea,
  defaultPMArea,
  getDefaultPreviewPath,
  TransitmodeComb,
  DirectionComb,
  SizeComb,
  FamilyComb,
  SpeedComb,
  OpacityComb,
  TextStyleComb,
  AlignComb,
  StyleComb,
  DateStyleComb,
  TimeStyleComb,
  WeatherStyleComb,
  ColorPickerComb,
  ColorPickerCircle,
  getDateParam,
  getTimeParam,
  getWeatherParam,
  canNotShowMaterial,
  showdate,
  showtime,
} from 'components/Playlist';
import { textEllipsis, getContentParam } from '@/utils/common';
import moment from 'moment';
import './style/mediaArea.less';
import './style/playlistComb.less';

const format = 'HH:mm:ss';
const FormItem = Form.Item;

const { Content, } = Layout;
export let preCount = 0; // 素材缩略图预览次数，为了解决子父间传值问题
export class PropertyButton extends Component {
	render() {
    let {
      type,
      currentArea: area,
      onCheckAll,
      checkAll,
      onDelete,
      mediaareaRows,
      onShowMediaModel,
    } = this.props;
    if(type !== 1) {
      return null;
    }
    if (!area) return null;
    if (area.areaType === 9) return null;
    const cantNotShowPic = canNotShowMaterial[area.areaType];
    if (cantNotShowPic) return null;
    let settingClassName = "ahover aactive";
    let disabledClassName = "disabled";
    return (
      <div className={"playlist-property-material-button"}>
        <div className={settingClassName} onClick={(event) => {
          onCheckAll && onCheckAll(event, 'mediaArea', null);
        }}>
          <Checkbox checked={checkAll()} onClick={(event) => {
            onCheckAll && onCheckAll(event, 'mediaArea', null);
          }}/>{checkAll() ? window.language['playlist.mediaarea.cancel'] : window.language['playlist.mediaarea.selectAll']}
        </div>
        <div className={settingClassName} onClick={(event) => {
          onDelete && onDelete(event, 'mediaArea', mediaareaRows);
        }}>
          <Icon className={"delete-o"}></Icon>{window.language['playlist.mediaarea.del']}
        </div>
        <div className={settingClassName} onClick={(e) => {
          onShowMediaModel && onShowMediaModel(true);
        }}>
          <Icon className={"menu-setting-o"}></Icon>{window.language['playlist.mediaarea.setting']}
        </div>
      </div>
    )
	}
}
export class PlaylistMaterial extends Component {
	constructor(props) {
    super();
    this.state = {
      dataMap: new Map(),
    }
  }
  changeDataMap = (props) => {
    let { 
			mediaAreas = [],
    } = props;
    let dataMap = new Map();
		let newMeidaArea = mediaAreas.map((media, index) => {
			let preview = getDefaultPreviewPath(media, '');
      let { filename, filetype, filesense, playtime, transitmode, refreshtime} = media;
      if (filetype === '0') {   // 视频
        filesense = "320x240";
      } else if (filetype === '1') {  // 图片

      } else if (filetype === '2') {  // 音乐
        filesense = '102x106';
      } else if (filetype === '7') { // 网页
        filesense = '102x106';
      } else if (filetype === '18') { // RSS
        filesense = '102x106';
      } else if (filetype === '15' || filetype === '16' || filetype === '17' || filetype === '35') {  // word、excel、ppt、pdf
        let previewList = media.previewList;
        if (previewList && previewList.length > 0) {
          preview = previewList[0].path;
          filesense = previewList[0].sense;
        }
      }
      let data = {
        name: filename,
        sense: filesense,
        src: preview,
      }
      dataMap.set(index, data);
    })
    this.setState({
      dataMap
    })
  }
  componentDidMount() {
    this.changeDataMap(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.changeDataMap(nextProps);
  }
	render() {
		let { 
			type,
			height,
			mediaAreas = [],
			mediaareaRows,
			onMouseDown,
			onMouseUp,
			onDragStart,
			onDragEnd,
			onDragEnter,
			onDragOver,
			onDrop,
			onDelete,
			onUp,
			onDown,
			onUpdateArea,
			onEdit,
			onShowMaterialModel,
			onShowMediaModel,
      onOperateMediaarea,
      onMaterialPreview,
      currentArea,
    } = this.props;
    let {
      dataMap,
    } = this.state;
    if (!dataMap) return null;
		let newMeidaArea = mediaAreas.map((media, index) => {
			let preview = getDefaultPreviewPath(media, '');
      let { filename, filetype, filesense, playtime, transitmode, refreshtime} = media;
      if(!refreshtime) {
        refreshtime ='23:59:59';
      }
			let liProps = {
        // draggable: type === 1 ? false : true,
        draggable: true,
				onMouseDown: (event) => {
					onMouseDown && onMouseDown(event, 'mediaArea', media);
				},
				onMouseUp: (event) => {
					onMouseUp && onMouseUp(event, 'mediaArea', media);
				},
				onDragStart: (event) => {
					onDragStart && onDragStart(event, 'mediaArea', media);
				},
				onDragEnd: (event) => {
					onDragEnd && onDragEnd(event, 'mediaArea', media);
				},
				onDragEnter: (event) => {
					onDragEnter && onDragEnter(event, 'mediaArea', media);
				},
				onDragOver: (event) => {
					onDragOver && onDragOver(event, 'mediaArea', media);
				},
				onDrop: (event) => {
					onDrop && onDrop(event, 'mediaArea', media);
				},
			}
			let selected = mediaareaRows.findIndex(val => {
				if(val.id && media.id){
					return val.id === media.id;
				}else{
					return false;
				}
			})
      let isChecked = selected > -1 ? true : false;
      
      let transitmodeProps = {
        size: 'small',
        value: transitmode, 
        // content, 
        selected: '', 
        filetype, 
        // changeTransitMode, 
        onEdit,
        onOperateMediaarea,
        rightMode: true,
      }
      let filesensediv = (
        <React.Fragment>
          <div {...liProps}>{window.language['playlist.mediaarea.sense']}</div>
          <div {...liProps}>：</div>
          <div className="text-ellipsis">{filesense}</div>
        </React.Fragment>
      )
      let playtimediv = (
        <React.Fragment>
          <div {...liProps}>{window.language['playlist.mediaarea.time']}</div>
          <div {...liProps}>：</div>
          <div>
            <TimePicker 
              size={"small"} 
              value={moment(playtime, format)} 
              // defaultValue={moment(playtime, format)}
              placeholder={''}
              format={format} 
              onChange={(value, valueString) => { 
                valueString && onOperateMediaarea && onOperateMediaarea(null, 'mediaArea', media, () => {
                  onEdit('playtime', 'mediaArea', valueString, ) 
                })
              }
            } readOnly disabled={filetype === '1' || filetype === '7' ? false : true}/>
          </div>
        </React.Fragment>
      )
      let refreshtimediv = (
        <React.Fragment>
          <div {...liProps}>{window.language['playlist.mediaarea.refresh']}</div>
          <div {...liProps}>：</div>
          <div>
            <TimePicker 
              size={"small"} 
              value={moment(refreshtime, format)} 
              // defaultValue={moment(playtime, format)}
              placeholder={''}
              format={format} 
              onChange={(value, valueString) => { 
                valueString && onOperateMediaarea && onOperateMediaarea(null, 'mediaArea', media, () => {
                  onEdit('refreshtime', 'mediaArea', valueString, ) 
                })
              }
            } readOnly disabled={filetype === '7' ? false : true}/>
          </div>
        </React.Fragment>
      )
      let transitmodediv = (
        <React.Fragment>
          <div {...liProps}>{window.language['playlist.mediaarea.special']}</div>
          <div {...liProps}>：</div>
          <div className="small-transitmode">
            <TransitmodeComb {...transitmodeProps} media={media}/>
          </div>
        </React.Fragment>
      )
      let materialPropertys = null;
      if(filetype === '0') {
        materialPropertys = (
          <React.Fragment>
            <div className={"playlist-property-material-property2"}>
              {
                filesensediv
              }
            </div>
            <div className={"playlist-property-material-property3"}>
              {
                playtimediv
              }
            </div>
            <div className={"playlist-property-material-property4"}>
            </div>
          </React.Fragment>
        )
      }else if(filetype === '1') {
        materialPropertys = (
          <React.Fragment>
            <div className={"playlist-property-material-property2"}>
              {
                filesensediv
              }
            </div>
            <div className={"playlist-property-material-property3"}>
              {
                playtimediv
              }
            </div>
            <div className={"playlist-property-material-property4"}>
              {
                transitmodediv
              }
            </div>
          </React.Fragment>
        )
      }else if (filetype === '7') {
        materialPropertys = (
          <React.Fragment>
            <div className={"playlist-property-material-property2"}>
              {
                playtimediv
              }
            </div>
            <div className={"playlist-property-material-property3"}>
              {
                refreshtimediv
              }
            </div>
            <div className={"playlist-property-material-property4"}>
            </div>
          </React.Fragment>)
      }else {
        materialPropertys = (
          <React.Fragment>
            <div className={"playlist-property-material-property2"}>
              {
                playtimediv
              }
            </div>
            <div className={"playlist-property-material-property3"}>
            </div>
            <div className={"playlist-property-material-property4"}>
            </div>
          </React.Fragment>
        )
      }
      if(currentArea.areaType === 9) {
        materialPropertys = (
          <React.Fragment>
            <div className={"playlist-property-material-property2"}>
              {
                filesensediv
              }
            </div>
            <div className={"playlist-property-material-property3"}>
              {
                playtimediv
              }
            </div>
            <div className={"playlist-property-material-property4"}>
            </div>
          </React.Fragment>
        )
      }

      let data = dataMap.get(index);
      if (!data) return null;
      let cssAnimate = data.src.indexOf("program/file-") > 0 ? "flipInY" : null;
			return (
				<li key={index} onMouseOver={() => {
          let data = dataMap.get(index);
          data.src = 'assets/images/program/file-' + filetype + '.png';
          this.setState({
            dataMap
          })
        }} onMouseOut={() => {
          let data = dataMap.get(index);
          data.src = preview;
          this.setState({
            dataMap
          })
        }}>
					<div className={"playlist-property-material-check"} {...liProps}>
						<Checkbox checked={isChecked} />
					</div>
					<div className={"playlist-property-material-content"}>
						<div className={"playlist-property-material-pic"} {...liProps}>
              <CSSAnimate type={ cssAnimate } duration={500} style={{display: 'inline-block', width: 111, height: 112}}>
                <PictureShow filetype="media" data={data} onDoubleClick={(event) => {
                    onOperateMediaarea && onOperateMediaarea(event, 'mediaArea', media, () => {
                      onMaterialPreview && onMaterialPreview(event, 'mediaArea', media);
                    })
                  }}/>
              </CSSAnimate>
						</div>
						<div className={"playlist-property-material-property"}>
							<div className={"playlist-property-material-property1"} {...liProps}>
								<div>{window.language['playlist.mediaarea.name']}</div>
								<div>：</div>
								<div alt={filename} title={filename}>{textEllipsis(filename, 7)}</div>
							</div>
              {
                materialPropertys
              }
						</div>
						<div className={"playlist-property-material-operate"}>
							<div className={"playlist-property-material-operate1"}>
								<div><Icon className={"up-arrow-o ahover aactive"} title={window.language['playlist.mediaarea.up']}
									onClick={(event) => {
										onOperateMediaarea && onOperateMediaarea(event, 'mediaArea', media, () => {
											onUp && onUp(event, 'mediaArea', media);
										})
									}}/></div>
							</div>
							<div className={"playlist-property-material-operate2"}>
								<div><Icon className={"down-arrow-o ahover aactive"} title={window.language['playlist.mediaarea.down']}
									onClick={(event) => {
										onOperateMediaarea && onOperateMediaarea(event, 'mediaArea', media, () => {
											onDown && onDown(event, 'mediaArea', media);
										})
									}}/></div>
							</div>
							<div className={"playlist-property-material-operate3"}>
								<div><Icon className={"replace-o ahover aactive"} title={window.language['playlist.mediaarea.upd']}
									onClick={(event) => {
										onOperateMediaarea && onOperateMediaarea(event, 'mediaArea', media, () => {
											onShowMaterialModel && onShowMaterialModel(true, 'update');
										})
									}}/></div>
							</div>
							<div className={"playlist-property-material-operate4"}>
								<div><Icon className={"delete-o ahover aactive"} title={window.language['playlist.mediaarea.del']}
									onClick={(event) => {
										onOperateMediaarea && onOperateMediaarea(event, 'mediaArea', media, () => {
											onDelete && onDelete(event, 'mediaArea', media);
										})
									}}/></div>
							</div>
						</div>
					</div>
				</li>
			)
		})
		return (
			<ul className="playlistMaterial" style={{height}}>
				{
					newMeidaArea
				}
			</ul>
		)
	}
}

export class PropertyFile extends Component {
	render() {
    let {
      currentArea: {areaType, mediaAreas},
      materialFileHeight,
    } = this.props;
    if (areaType === 9) {
      if (mediaAreas.length !== 0) {
        materialFileHeight = materialFileHeight + 120;
      }
      materialFileHeight = materialFileHeight - 184;
    }

    return (
      <div className={"playlist-property-material-file"} style={{height: materialFileHeight}}>
        <PlaylistMaterial {...this.props} height={materialFileHeight} />
      </div>
    )
	}
}
export class PropertyAdd extends Component {
	render() {
    let {
      type,
      currentArea: area,
      onShowMaterialModel,
    } = this.props;
    if (!area) return null;
    const cantNotShowPic = canNotShowMaterial[area.areaType];
    if(type !== 1) {
      return null;
    }
    if (cantNotShowPic) {
      return null;
    }
    if(area.areaType === 9 && area.mediaAreas.length !== 0){
      return null;
    }
		return (
      <div className={"playlist-property-add"} onClick={(e) => {
          onShowMaterialModel && onShowMaterialModel(true, 'add');
        }}>
        <Icon className="add-o ahover aactive" />
      </div>
    )
	}
}
export class AreaProperty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preVisible : false, //预览
    }
  }

  render() {
    let { 
      // type,
      fontPageData, templatewidth, templateheight,
      // materialFileHeight, mediaareaRows, playtime, transitmode, transittime,
      currentArea: area,  
      // onMouseDown, onMouseUp, onDragStart, onDragEnd,
      // onDragEnter, onDragOver, onDrop, onDelete, onUp, onDown, onEdit, 
      onChange, 
      onUpdateArea,
      // onCheckAll, checkAll, onShowMaterialModel, onShowMediaModel, onOperateMediaarea,
    } = this.props;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      style: { marginBottom: 20 },
    };
    const colorFormItemLayout = {
      ...formItemLayout
    };
    let areaType = area.areaType;
    let commonWidth = '90%';
    let colorCommonWidth = 37;
    if(2 === areaType){
      let {
        color, rollmode, size, family,
        bgcolor, rollspeed, opacity, playtime,
      } = area.textArea || defaultTextArea;
        return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row className={"customProperty familyComb"}>
            <Col span={24} >
              <FamilyComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ family } 
                defaultValue={ family } 
                width={ commonWidth }
                onSelect={(family) => { 
                  onUpdateArea(null, 'textArea', 'family', family);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row className={"customProperty colorPicker"}>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'textArea', 'color', color.hex);
                } } 
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <SizeComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ size } 
                defaultValue={ size } 
                width={ commonWidth }
                onSelect={(size) => { 
                  onUpdateArea(null, 'textArea', 'size', size);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.bgcolor']}
                color={bgcolor} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'textArea', 'bgcolor', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.bgcolor']} style={{ marginBottom: colorFormItemLayout.style.marginBottom }}>
                <ColorPicker type='ChromePicker'
                  color={bgcolor} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'textArea', 'bgcolor', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row className={"opacityComb"}>
            <Col span={24}>
              <OpacityComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ opacity } 
                defaultValue={ opacity } 
                width={ commonWidth }
                onSelect={(opacity) => { 
                  onUpdateArea(null, 'textArea', 'opacity', opacity);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row className={"speedComb"}>
            <Col span={24}>
              <SpeedComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ rollspeed } 
                defaultValue={ rollspeed } 
                width={ commonWidth }
                onSelect={(rollspeed) => { 
                  onUpdateArea(null, 'textArea', 'rollspeed', rollspeed);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row className={"directionComb"}>
            <Col span={24}>
              <DirectionComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ rollmode } 
                defaultValue={ rollmode } 
                width={ commonWidth }
                onSelect={(rollmode) => { 
                  onUpdateArea(null, 'textArea', 'rollmode', rollmode);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row style={{display: 'none'}}>
            <Col span={24}>
              <FormItem {...formItemLayout} label={window.language['playlist.continue.time']}>
                <TimePicker 
                  size={"small"} 
                  value={playtime ? moment(playtime, format) : null} 
                  // defaultValue={moment(playtime, format)}
                  placeholder={''}
                  format={format} 
                  style={{ width: commonWidth }}
                  onChange={(value, valueString) => {
                    onUpdateArea(null, 'textArea', 'playtime', valueString, ) 
                  }} 
                  readOnly />
              </FormItem>
            </Col>
          </Row>
        </div>
      )
    }else if(3 === areaType){
      let {
        color, family, size, style,
      } = area.dateArea || defaultDateArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'dateArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'dateArea', 'color', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DateStyleComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ style } 
                values={ ['7', '8', '9', '10', '1', '2', '3', '4', '5'] }
                defaultValue={ style } 
                width={ commonWidth }
                onSelect={(style) => { 
                  onUpdateArea(null, 'dateArea', 'style', style);
                  let content = showdate(style);
                  let divSize = getContentParam(content, size);
                  let { width, height } = divSize;
                  width += 2 + 7;
                  let { left, top, areaId, areaType, zIndex } = area;
                  if(left + width > templatewidth){
                    left = templatewidth - width;
                  }
                  if(top + height > templateheight){
                    top = templateheight - height;
                  }
                  onChange({left, top, width, height, areaId, areaType, zIndex});
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <SizeComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ size } 
                defaultValue={ size } 
                width={ commonWidth }
                onSelect={(size) => { 
                  onUpdateArea(null, 'dateArea', 'size', size);
                  let content = showdate(style);
                  let divSize = getContentParam(content, size);
                  let { width, height } = divSize;
                  width += 2 + 7;
                  let { left, top, areaId, areaType, zIndex } = area;
                  if(left + width > templatewidth){
                    left = templatewidth - width;
                  }
                  if(top + height > templateheight){
                    top = templateheight - height;
                  }
                  onChange({left, top, width, height, areaId, areaType, zIndex});
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FamilyComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ family } 
                defaultValue={ family } 
                width={ commonWidth }
                onSelect={(family) => { 
                  onUpdateArea(null, 'dateArea', 'family', family);
                }} 
                readOnly/>
            </Col>
          </Row>
        </div>
      )
    }else if(4 === areaType){
      let {
        color, family, size, style,
      } = area.timeArea || defaultTimeArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'timeArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'timeArea', 'color', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <TimeStyleComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ style } 
                values={ ['1', '2', '3', '4',] }
                defaultValue={ style } 
                width={ commonWidth }
                onSelect={(style) => { 
                  onUpdateArea(null, 'timeArea', 'style', style);
                  let content = showtime(style);
                  let divSize = getContentParam(content, size);
                  let { width, height } = divSize;
                  width += 2;
                  let { left, top, areaId, areaType, zIndex } = area;
                  if(left + width > templatewidth){
                    left = templatewidth - width;
                  }
                  if(top + height > templateheight){
                    top = templateheight - height;
                  }
                  onChange({left, top, width, height, areaId, areaType, zIndex});
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <SizeComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ size } 
                  defaultValue={ size } 
                  width={ commonWidth }
                  onSelect={(size) => { 
                    onUpdateArea(null, 'timeArea', 'size', size);
                    let content = showtime(style);
                    let divSize = getContentParam(content, size);
                    let { width, height } = divSize;
                    width += 2;
                    let { left, top, areaId, areaType, zIndex } = area;
                    if(left + width > templatewidth){
                      left = templatewidth - width;
                    }
                    if(top + height > templateheight){
                      top = templateheight - height;
                    }
                    onChange({left, top, width, height, areaId, areaType, zIndex});
                  }} 
                  readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <FamilyComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ family } 
                  defaultValue={ family } 
                  width={ commonWidth }
                  onSelect={(family) => { 
                    onUpdateArea(null, 'timeArea', 'family', family);
                  }} 
                  readOnly/>
            </Col>
          </Row>
        </div>
      )
    }else if(5 === areaType){
      let {
        color, family, size, style, 
      } = area.weatherArea || defaultWeatherArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'weatherArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'weatherArea', 'color', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <WeatherStyleComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ style } 
                defaultValue={ style } 
                width={ commonWidth }
                onSelect={(style) => { 
                  onUpdateArea(null, 'weatherArea', 'style', style);
                  let divSize = getWeatherParam(size, style);
                  let width = divSize[0];
                  let height = divSize[1];
                  let { left, top, areaId, areaType, zIndex } = area;
                  if(left + width > templatewidth){
                    left = templatewidth - width;
                  }
                  if(top + height > templateheight){
                    top = templateheight - height;
                  }
                  onChange({left, top, width, height, areaId, areaType, zIndex});
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <SizeComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ size } 
                values={ [20, 25, 30, 40,] }
                defaultValue={ size } 
                width={ commonWidth }
                onSelect={(size) => { 
                  onUpdateArea(null, 'weatherArea', 'size', size);
                  let divSize = getWeatherParam(size, style);
                  let width = divSize[0];
                  let height = divSize[1];
                  let { left, top, areaId, areaType, zIndex } = area;
                  if(left + width > templatewidth){
                    left = templatewidth - width;
                  }
                  if(top + height > templateheight){
                    top = templateheight - height;
                  }
                  onChange({left, top, width, height, areaId, areaType, zIndex});
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FamilyComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ family } 
                defaultValue={ family } 
                width={ commonWidth }
                onSelect={(family) => { 
                  onUpdateArea(null, 'weatherArea', 'family', family);
                }} 
                readOnly/>
            </Col>
          </Row>
        </div>
      )
    }else if(9 === areaType){
      let {
        bgcolor, 
      } = area.bgArea || defaultBgArea;

      return (
        <div style={{position: 'relative', top: 5, textAlign: 'right', marginBottom: 25, color: '#c0c0c0'}}>
          <ColorPickerCircle
            type='ChromePicker'
            formItemProps={colorFormItemLayout}
            label={window.language['playlist.bgcolor']}
            color={bgcolor} 
            width={ colorCommonWidth }
            onChange={ (color) => {
              onUpdateArea(null, 'bgArea', 'bgcolor', color.hex);
            } } 
						onClick={ (color) => {
							onUpdateArea(null, 'bgArea', 'bgcolor', color);
						} } 
					/>
          <span>{window.language['playlist.usedcolor']}</span>
        </div>
      )
    }else if(18 === areaType){
      let {
        color, size, family, familyId,
        bold, italic, underline, align,
      } = area.sTextArea || defaultSTextArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'sTextArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'sTextArea', 'color', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <SizeComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ size } 
                  defaultValue={ size } 
                  width={ commonWidth }
                  onSelect={(size) => { 
                    onUpdateArea(null, 'sTextArea', 'size', size);
                  }} 
                  readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FamilyComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ familyId } 
                values={ fontPageData.list }
                defaultValue={ family } 
                width={ commonWidth }
                onSelect={(family, {props: {value: key, children: value}}) => { 
                  onUpdateArea(null, 'sTextArea', 'family', value);
                  onUpdateArea(null, 'sTextArea', 'familyId', key);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <TextStyleComb
                formItemProps={formItemLayout} 
                size={"small"} 
                bold={ bold } 
                italic={ italic } 
                underline={ underline } 
                width={ commonWidth }
                updateBold={(bold) => { 
                  onUpdateArea(null, 'sTextArea', 'bold', bold);
                }}
                updateItalic={(italic) => { 
                  onUpdateArea(null, 'sTextArea', 'italic', italic);
                }}
                updateUnderline={(underline) => { 
                  onUpdateArea(null, 'sTextArea', 'underline', underline);
                }}
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <AlignComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  align={ align } 
                  width={ commonWidth }
                  updateAlign={(align) => { 
                    onUpdateArea(null, 'sTextArea', 'align', align);
                  }} 
                  readOnly/>
            </Col>
          </Row>
        </div>
      )
    }else if(19 === areaType){
      let {
        family, size, color, bgcolor,
      } = area.floorArea || defaultFloorArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'floorArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'floorArea', 'color', color.hex);
                  } } 
                  />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={bgcolor} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'floorArea', 'bgcolor', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.bgcolor']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={bgcolor} 
                  width={ 24 }
                  onChange={ (color) => {
                    onUpdateArea(null, 'floorArea', 'bgcolor', color.hex);
                  } } 
                  />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FamilyComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ family } 
                defaultValue={ family } 
                width={ commonWidth }
                onSelect={(family) => { 
                  onUpdateArea(null, 'floorArea', 'family', family);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <SizeComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ size } 
                defaultValue={ size } 
                width={ commonWidth }
                onSelect={(size) => { 
                  onUpdateArea(null, 'floorArea', 'size', size);
                }} 
                readOnly/>
            </Col>
          </Row>
        </div>
      )
    }else if(78 === areaType){
      let {
        color, rollmode, size, family,
        bgcolor, rollspeed, opacity, playtime,
      } = area.pmArea || defaultPMArea;
      return (
        <div style={{position: 'relative', top: '5px'}}>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.font.color']}
                color={color} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'pmArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.font.color']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={color} 
                  width={ colorCommonWidth }
                  onChange={ (color) => {
                    onUpdateArea(null, 'pmArea', 'color', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DirectionComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ rollmode } 
                defaultValue={ rollmode } 
                width={ commonWidth }
                onSelect={(rollmode) => { 
                  onUpdateArea(null, 'pmArea', 'rollmode', rollmode);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <SizeComb
                formItemProps={formItemLayout} 
                size={"small"} 
                value={ size } 
                defaultValue={ size } 
                width={ commonWidth }
                onSelect={(size) => { 
                  onUpdateArea(null, 'pmArea', 'size', size);
                }} 
                readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <FamilyComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ family } 
                  defaultValue={ family } 
                  width={ commonWidth }
                  onSelect={(family) => { 
                    onUpdateArea(null, 'pmArea', 'family', family);
                  }} 
                  readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <ColorPickerComb type='ChromePicker'
                formItemProps={colorFormItemLayout}
                label={window.language['playlist.bgcolor']}
                color={bgcolor} 
                width={ colorCommonWidth }
                onChange={ (color) => {
                  onUpdateArea(null, 'pmArea', 'color', color.hex);
                } } 
              />
              {/* <FormItem {...colorFormItemLayout} label={window.language['playlist.bgcolor']} style={{ marginBottom: 0 }}>
                <ColorPicker type='ChromePicker'
                  color={bgcolor} 
                  width={ 24 }
                  onChange={ (color) => {
                    onUpdateArea(null, 'pmArea', 'bgcolor', color.hex);
                  } } 
                />
              </FormItem> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <SpeedComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ rollspeed } 
                  defaultValue={ rollspeed } 
                  width={ commonWidth }
                  onSelect={(rollspeed) => { 
                    onUpdateArea(null, 'pmArea', 'rollspeed', rollspeed);
                  }} 
                  readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
                <OpacityComb
                  formItemProps={formItemLayout} 
                  size={"small"} 
                  value={ opacity } 
                  defaultValue={ opacity } 
                  width={ commonWidth }
                  onSelect={(opacity) => { 
                    onUpdateArea(null, 'pmArea', 'opacity', opacity);
                  }} 
                  readOnly/>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem {...formItemLayout} label={window.language['playlist.continue.time']}>
                <TimePicker 
                  size={"small"} 
                  value={playtime ? moment(playtime, format) : null} 
                  // defaultValue={moment(playtime, format)}
                  placeholder={''}
                  format={format} 
                  style={{ width: commonWidth }}
                  onChange={(value, valueString) => {
                    onUpdateArea(null, 'pmArea', 'playtime', valueString, ) 
                  }} 
                  readOnly />
              </FormItem>
            </Col>
            </Row>
        </div>
      )
    }else {
      return null;
    }
  }
}
export class MediaArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preVisible : false, //预览
    }
  }

  render() {
    let { 
      type,
      fontPageData, templatewidth, templateheight, materialFileHeight,
      mediaareaRows, playtime, transitmode, transittime,
      currentArea: area,  
      onMouseDown, onMouseUp, onDragStart, onDragEnd,
      onDragEnter, onDragOver, onDrop,
      onDelete, onUp, onDown, onEdit, onChange, 
      onUpdateArea, onCheckAll, checkAll,
      onShowMaterialModel, onShowMediaModel, onOperateMediaarea, onMaterialPreview,
    } = this.props;

    const areaPropertyProps = {
      fontPageData, templatewidth, templateheight,
      currentArea: area,  
      onChange, 
      onUpdateArea,
    }
    if (!area) return null;
    const cantNotShowPic = canNotShowMaterial[area.areaType];
    materialFileHeight = cantNotShowPic ? materialFileHeight + 115 + 35 : materialFileHeight;
    const mediaAreaProps = {
      type,
      currentArea: area,
      mediaAreas: area.mediaAreas || [],
      mediaareaRows,
      draggable: true,
      onMouseDown,
      onMouseUp,
      onDragStart,
      onDragEnd,
      onDragEnter,
      onDragOver,
      onDrop,
      onUp,
      onDown,
      onDelete,
      onCheckAll,
      checkAll,
      onUpdateArea,
      onEdit,
      onShowMaterialModel,
      onShowMediaModel,
      onOperateMediaarea,
      onMaterialPreview,
      materialFileHeight,
      style: { userSelect: 'none' },
    }
    return (
      <div className={"playlist-property-material"}>
        {
          cantNotShowPic || area.areaType === 2 ? ( // 文本特殊，可以添加素材，但是无素材展示
            <React.Fragment>
              <AreaProperty {...areaPropertyProps}/>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <PropertyButton {...mediaAreaProps}/>
              <AreaProperty {...areaPropertyProps}/>
              <PropertyFile {...mediaAreaProps}/>
              <PropertyAdd {...mediaAreaProps} />
            </React.Fragment>
          )
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Playlist/MediaArea.js